import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { useCoreEvents } from '../../hooks/CoreEventsProvider';
import EmptyState from '../../components/EmptyState';
import { formatTime } from '../../utils/format';

const EventsTab = () => {
  const { events, isPaused, hasError, setPaused, clear } = useCoreEvents();

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 1.5 }}>
        Event log of the core service (<code>/events</code>): state changes from Redmine journals and snapshots,
        new/removed instances, workflow violations. Refreshed every few seconds while the page is open.
      </Typography>
      <Stack direction="row" gap={1} alignItems="center" sx={{ marginBottom: 1.5 }}>
        <Button variant="outlined" size="small" onClick={() => setPaused(!isPaused)}>
          {isPaused ? 'Resume' : 'Pause'}
        </Button>
        <Button variant="text" size="small" disabled={!events.length} onClick={clear}>
          Clear
        </Button>
        {hasError ? <Chip size="small" color="error" variant="outlined" label="events unavailable" /> : null}
        <Typography variant="caption" color="text.secondary">
          {events.length} events
        </Typography>
      </Stack>
      <Paper variant="outlined" sx={{ padding: '4px 12px' }}>
        {events.length ? (
          events.map(event => (
            <Box
              key={event.id}
              sx={{
                padding: '4px 0',
                borderBottom: 1,
                borderColor: 'divider',
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                fontSize: 12,
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap',
                '&:last-of-type': { borderBottom: 0 },
              }}
            >
              {formatTime(event.occurredAt)} {event.type.padEnd(20)} {event.channel.padEnd(8)} {event.instanceId ?? ''}{' '}
              {JSON.stringify(event.payload)}
            </Box>
          ))
        ) : (
          <EmptyState>No events yet</EmptyState>
        )}
      </Paper>
    </Box>
  );
};

export default EventsTab;
